export default __webpack_public_path__ + "f2a23d60ceba3f2fd733aa1475cbcf4a.woff2";